// 学生激活提交方法公用
import axios from 'axios'
import qs from 'qs'
import { Message,Loading} from 'element-ui'
import router from '../../router/index.js'
let loading
const startLoading = () => {
    loading = Loading.service({
        lock: true,
        target: 'body'
    });
};
const endLoading = () => {
    loading.close();
};
export default {
    // 参数： url 路由跳转地址  form提交表单数据  askUrl请求接口地址
    SubmitActive:function(url,form,askUrl){
                startLoading()
                axios.post(askUrl,qs.stringify(form))
                    .then(res => {
                        endLoading()
                        if (res.data.ErrorCode == 0) {//保存成功
                            router.push({path:url})
                        }else if(res.data.ErrorCode == 1){
                            Message.error({
                                    message:res.data.ErrorMsg,
                                    type:"error",
                                    duration:3000
                            })
                        }
                    }).catch(err => {//指向错误页面之前关闭加载
                        endLoading()
                    })
            }, 
}


// WEBPACK FOOTER //
// ./src/assets/js/submitActive.js